module.exports = __webpack_public_path__ + "static/media/15UN-Habitat8.59058321.jpg";